/**
 * Browser-unique client ID (UUID v7) for API headers (e.g. x-client-id).
 * Stored in localStorage and reused across sessions.
 * Mirrors the deviceId concept from React Native (useAuthInitializer / authState).
 */

import { uuidv7 } from 'uuidv7';

const STORAGE_KEY = 'fancian-admin-client-id';

/**
 * Returns the client ID for this browser. Creates and stores a UUID v7 on first use.
 * @returns {string} UUID v7 string
 */
export function getClientId() {
  if (typeof window === 'undefined' || !window.localStorage) {
    return uuidv7();
  }
  try {
    let id = window.localStorage.getItem(STORAGE_KEY);
    if (!id || typeof id !== 'string') {
      id = uuidv7();
      window.localStorage.setItem(STORAGE_KEY, id);
    }
    return id;
  } catch {
    return uuidv7();
  }
}
